import userLogConf from "./user_log";
import BaseSelect from "@/views/crud/modules/BaseSelect";

export default {
  key: "user",
  export: ["excel"],
  filters: {
    id: {},
    name: {},
    username: {},
    email: {},
    active: {
      default: 1,
      type: "boolean"
    },
    cp_loc_flag: {
      type: "boolean"
    },
    role_id: {
      type: "select",
      label: "name_chi",
      value: "id",
    },
  },
  // trash: true,
  fields: [
    { key: "id", width:80 },
    { key: "name", rules: ["required"] },
    { key: "role_id", field: "roles.name_chi", type: "select", rules: ["required"] },
    { key: "username", rules: ["required"] },
    { key: "email" },
    { key: "password", hidden: ["read", "list"], password: true, protected: true, rules: ["required", "not-required-in-edit"] },
    { key: "confirm_password", hidden: ["read", "list"], password: true, protected: true, rules: ["required", "not-required-in-edit"] },
    { key: "active", width:50, type: "boolean" },
    { key: "cp_loc_flag", width:50, type: "boolean" },
    { key: "loc_id", type:"componentColumn", component:BaseSelect, filterable:true, optionKey: "cp_locs", setup:{label:'label',value:'value'}, disabledFun:d=>d.cp_loc_flag==1, hidden: ["list"]},
    { type: "action-btn", width:120 }
    // { key: "password" },
  ],
  structure: [
    ["name","role_id"],
    ["username"],
    ["email"],
    ["password"],
    ["confirm_password"],
    ["active"],
    ["cp_loc_flag"],
    ["loc_id"]
  ],
  action: ["create","edit","view","delete"],
  options: {
    role_id: {
      key: "roles",
      label: "name_chi",
      value: "id"
    },
    loc_id: {
      key: "cp_locs",
      label: "address",
      value: "loc_id"
    },
  },
  default: {
    active: 1
  },
  view: [
    ["id"],
    ["name",{ key: "role_id", type: "array", field: "roles", value: "name_chi" }],
    ["username"],
    ["email"],
    [{ key: "active", type: "boolean" }],
    [{ key: "cp_loc_flag", type: "boolean" }],
    [{ key: "loc_id", type:"componentColumn", component:BaseSelect, filterable:true, optionKey: "cp_locs", setup:{label:'label',value:'value'} }],
    [{
      type: "tabs",
      items: [
        {
          // type: "related_info",
          key: "user_log",
          params: ["username"],
          name: "user_log",
          ...userLogConf
        }
      ]
    }]
  ]
}